import moment from 'moment';

import {
    PDFWriter
} from 'complionUtil/PDFWriter';
import { DATE_FORMAT } from './DelegationAuditLog';


export default class Export {
    constructor(PDFWriterClass = PDFWriter) {
        this.pdfWriter = new PDFWriterClass();
        this.sections = new Array();
    }

    /**
     * Registers a compatible Export Section.
     * @param {ExportSection} section 
     * @returns {Number} The number of registered sections.
     */
    register(section) {
        if(!section.append || typeof section.append !== 'function') {
            throw new Error('The Export section you attempted to register is not compatible.');
        }

        return this.sections.push(section);
    }

    /**
     * Generates a PDF containing one or many sections.
     * @param {String} fileName 
     */
    generate(fileName) {
        if (this.sections.length < 1) {
            throw new Error('Cannot generate an Export PDF file without any sections! Please register a section first.');
        }
        this.sections.forEach(section => section.append(this.pdfWriter));
        this.save(fileName);
    }

    /**
     * Tags each page with the page heading, including page count and export date.
     * @param {String} exportDate 
     * @private
     */
    tagPageHeaders(exportDate) {
        this.pdfWriter.writePageHeaders(exportDate);
    }

    /**
     * @returns {String} Current date.
     * @private
     */
    getExportDate() {
        return moment().format(DATE_FORMAT);
    }

    /**
     * Writes a pdf file with the provided name.
     * @param {String} fileName
     * @private
     */
    save(fileName) {
        const exportDate = this.getExportDate();
        this.tagPageHeaders(exportDate);
        this.pdfWriter.savePDF(`${fileName}-${exportDate}.pdf`);
    }
}